"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _history = require("history");

const history = (0, _history.createHashHistory)();
var _default = history;
exports.default = _default;